import type { SearchQueryBody } from "@/types";

/**
 * Query key factory for collection queries. List keys are org-scoped so that
 * switching organizations cannot leak a previous org's cached entries.
 * Detail keys are identified by the globally unique collectionId.
 */
export const collectionQueryKeys = {
  // Org-scoped list keys
  all: (orgId: string) => ["collections", orgId] as const,
  lists: (orgId: string) =>
    [...collectionQueryKeys.all(orgId), "list"] as const,
  list: (orgId: string | undefined, query: SearchQueryBody) =>
    [
      ...(orgId ? collectionQueryKeys.lists(orgId) : ["collections", "list"]),
      query,
    ] as const,

  // Detail keys — collectionId is globally unique
  details: () => ["collection", "details"] as const,
  detail: (collectionId: string | undefined) =>
    [...collectionQueryKeys.details(), collectionId] as const,

  // Change history — nested under detail so invalidating a collection's detail
  // key also wipes its cached changes
  changes: (collectionId: string | undefined) =>
    [...collectionQueryKeys.detail(collectionId), "changes"] as const,
};
